'use client';
import { createContext, useContext } from 'react';
const AskInputBoundaryContext = createContext(null);
export const AskInputBoundaryProvider = AskInputBoundaryContext.Provider;
export function useAskInputBoundary() {
    return useContext(AskInputBoundaryContext);
}
//# sourceMappingURL=AskInputBoundaryShared.js.map